import { __ } from "@wordpress/i18n";
import parse from "html-react-parser";
import { useContext, useEffect, useState } from "react";
import { SettingsContext } from "../../Settings";
import ToggleSettingSection from "../../common/ToggleSettingSection";

const GDPRSection = () => {
  const { register, settings, watch } = useContext(SettingsContext);
  const gdprField = watch("gdpr");
  const [currentValue, setCurrentValue] = useState(settings.gdpr);

  useEffect(() => {
    setCurrentValue(gdprField);
    window.sby_settings.settings.gdpr = gdprField;
  }, [gdprField]);

  return (
    <>
      <div
        className={`sb-tab-box clearfix ${
          currentValue === "yes" ? "sb-reset-box-style" : ""
        }`}
      >
        <div className="tab-label">
          <h3>{__("GDPR", "feeds-for-youtube")}</h3>
        </div>
        <div className="sby-tab-form-field">
          <div className="sb-form-field">
            <div className="d-flex mb-2">
              <select
                {...register("gdpr")}
                id="gdpr-option"
                className="sby-select"
                defaultValue={settings.gdpr}
              >
                <option value="auto">
                  {__("Automatic", "feeds-for-youtube")}
                </option>
                <option value="yes">{__("Yes", "feeds-for-youtube")}</option>
                <option value="no">{__("No", "feeds-for-youtube")}</option>
              </select>
            </div>
            <span className="help-text">
              {parse(
                __(
                  "We will automatically enable GDPR compliance if we detect a supported privacy consent plugin. <a href='https://smashballoon.com/doc/feeds-for-youtube-gdpr-compliance/?youtube' target='_blank'>Learn More</a>",
                  "feeds-for-youtube"
                )
              )}
            </span>
          </div>
        </div>
      </div>
      {currentValue === "yes" && (
        <ToggleSettingSection
          title={__("Block CDN Images", "feeds-for-youtube")}
          inputName={"disablecdn"}
          defaultChecked={settings.disablecdn}
        />
      )}
    </>
  );
};

export default GDPRSection;
